import type { UserRoleEnum } from "@globals";

/**
 * Map of role enum values to their badge colors
 */
export const roleColors = new Map<UserRoleEnum, string>([
  ["team_admin", "red"],
  ["member", "blue"],
  ["read_only", "gray"]
]);
